module.exports = __webpack_public_path__ + "static/media/mex.fc93bc0f.png";